/*
Hinge Plates

  --thickness <float::enum> | millimeters | [0, 3, 6, 9, 18]
  --wedges <bool> | checkbox
*/

import hardwareHeaders from '@/modules/standardItems/schemas/hardware/headers'

export default [
  ...hardwareHeaders,
  {
    text: 'Thickness (mm)',
    value: 'thickness',
    sortable: true,
    sort: 'number',
    unit: 'millimeters'
  },
  {
    text: 'Wedges',
    value: 'wedges',
    sortable: true,
    sort: 'boolean',
    render: 'boolean'
  }
]
